// extracted by mini-css-extract-plugin
module.exports = {"date":"FirstColCellContent_date__aH_cT","month":"FirstColCellContent_month__22U6u"};